// Stage "kind" → visual treatment. Kinds come from the backend stage machine:
// open (normal), won, lost.
export const STAGE_KIND_STYLES = {
  open: { dot: "bg-blue-500", header: "text-slate-700" },
  won:  { dot: "bg-emerald-500", header: "text-emerald-700" },
  lost: { dot: "bg-red-500", header: "text-red-600" },
}

export const DEAL_STATUS_BADGE = {
  open: "info",
  won:  "success",
  lost: "destructive",
}

export const DEAL_STATUS_LABEL = {
  open: "Open",
  won:  "Won",
  lost: "Lost",
}

// Indian-format currency. Values come back as numbers (rupees).
export function formatMoney(value) {
  if (value == null || value === "") return "—"
  const n = Number(value)
  if (Number.isNaN(n)) return "—"
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n)
}

export function formatDate(iso) {
  if (!iso) return "—"
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
}
